import { render } from "./OrganizationSelection.vue?vue&type=template&id=c06eb588"
import script from "./OrganizationSelection.vue?vue&type=script&lang=js"
export * from "./OrganizationSelection.vue?vue&type=script&lang=js"

import exportComponent from "C:\\pirca\\Forge.Ruky\\PircaSolutions.Forge.Ruky.Backoffice.UI\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__